<template>
    <ModalFormCard class="modal-default lg:min-w-[600px]"
        :action='action'
        :class='{ 
            "!w-[800px]": value.previewImage == null,
            "!w-auto": value.previewImage != null
        }'
    >
        <template #title>Image select</template>
        <!-- Select image for {{ !options.workImage ? editingModel.tag.tag : 'work' }} -->

        <template #default="{ saving, errors }">
            <template v-if='value.previewImage == null && showUploader == false'>
                <Select :options="folders" v-model:value="value.folder" @update:value="getImages" class="w-full" />

                <div class='grid grid-cols-3 gap-4 mt-4' v-if='selectableImagesComputed.length > 0'>
                    <template v-for='image in selectableImagesComputed'>
                        <div class='border border-grey-500 aspect-square' @click.stop='setPreviewImage(image)'>
                            <!-- <img :src='lpUrl(image.image)' v-if='value.folder == "Default" || value.folder == "Landing page uploads"' /> -->
                            <FilePreview :img="image.image" :example="examples ? img : false" :noClick='true' />
                        </div>
                    </template>
                </div>

                <InputCheckbox class='mt-4' :checked='value.showNonTradeImage' 
                    @update:value='value.showNonTradeImage = !value.showNonTradeImage'
                    v-if='value.folder == "Default"'
                >
                    <p class='text-grey-900 pl-2.5 text-14'>Show all trade images</p>
                </InputCheckbox>

                <button class='button-black default h-12 px-6 mt-6' type='button' 
                    @click='showUploader = value.folder'
                    v-if='[101, 102, 103, 104].indexOf(value.folder) != -1'
                >
                    Upload images
                </button>
            </template>

            <template v-if='value.previewImage != null'>
                <input type="hidden" name="upload_id" :value="value.previewImage.image.id" />

                <template v-if='value.folder == "Default" || value.folder == "Landing page uploads"'>
                    <input type="hidden" name="is_old_upload" :value="true" />
                    <img class='w-full border border-grey-500' :src='lpUrl(value.previewImage.image)' />
                </template>

                <ImageEditor :image="value.previewImage.image" :tag='editingModel' ref="imageEditor" v-else />

                <div class="modal-buttons !grid-cols-6">
                    <ButtonSaving class="button-black default h-12" :disabled="saving">
                        Use this image
                    </ButtonSaving>

                    <button class="button-black-outline default h-12" 
                        :disabled="saving" type='button'
                        @click='downloadPreview'                        
                    >
                        Download
                    </button>

                    <button class="button-purple default" type="button" @click="value.previewImage = null">Back</button>
                </div>
            </template>

            <template v-if='showUploader'>
                <ImageUploader
                    :adminOverride='true'
                    :minBoxes="3"
                    :company="company"
                    :images="images"
                    :folderId="value.folder"
                    :cols="3"
                />

                <button class='button-black default h-12 px-6 mt-6' type='button' 
                    @click='showUploader = false; getImages()'
                >
                    Choose image
                </button>
            </template>

        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import ImageUploader from '~/components/customer/input/onboarding-image-uploader.vue'
import ImageEditor from '~/components/customer/input/image-editor.vue'

export default {
    mixins: [Modal],

    beforeMount() {},

    data() {
        return {
            showUploader: false,

            value: {
                folder: 'Default',
                showNonTradeImage: false,
                previewImage: null
            },
            folders: [
                { html: 'Default', value: 'Default' },
                { html: 'Landing page uploads', value: 'Landing page uploads' },
                { html: 'Logos', value: 101 },
                { html: 'Vans', value: 102 },
                { html: 'Work', value: 103 },
                { html: 'Team', value: 104 },
            ],
            images: [],
            selectableImages: []
        }
    },

    created() {
        this.getImages();
    },

    methods: {
        getImages() {
            this.selectableImages = []

            let url = `/uploads/${this.company.id}?folder=${this.value.folder}`;

            switch (this.value.folder) {
                case 'Default': url = '/zapo/landing-page/default-images'; break;
                case 'Landing page uploads': url = '/zapo/landing-page/uploaded-images'; break;
            }

            this.$axios.post(url, {
                tag_id: this.editingModel.tag_id,
                client_id: this.options.workImage ? this.editingModel.id : this.editingModel.client_id
            })
                .then(res => {
                    // console.log(res.isArray())
                    this.images = res.images == undefined ? res : res.images;
                    this.selectableImages = this.images

                    if (this.value.folder != 'Default') {
                        this.selectableImages = this.images.map(a => {
                            return {
                                image: a
                            }
                        })
                    }

                })
        },

        async downloadPreview() {
            if (!this.value.previewImage || !this.value.previewImage.image) {
                return;
            }
            
            const image = this.value.previewImage.image;
            const url = useRuntimeConfig().public.landingPageURL + image.file_name.replace("public", "/storage");
            
            try {
                const response = await fetch(url);
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = image.file_name.split('/').pop() || 'image';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                // Clean up the blob URL
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Download failed:', error);
            }
        },

        lpUrl(image) {
            return useRuntimeConfig().public.landingPageURL + image.file_name.replace("public", "/storage");
        },

        setPreviewImage(image) {
            this.value.previewImage = image;
        }
    },

    computed: {
        company() {
            return this.options.company;
        },

        selectableImagesComputed() {
            return this.selectableImages.filter(i => {
                return (i.image != null && i.image.file_name != null)
                    && ((this.value.showNonTradeImage || this.value.folder != "Default") || (!this.showNonTradeImage && i.industry_id == this.company.industry_id));
            })
        },

        action() {
            if (this.options.workImage != null) {
                return "/zapo/landing-page/work-image/" + this.editingModel.id;
            }

            return "/zapo/landing-page/client-tag/" + this.editingModel.id
        }
    },

    components: {
        ImageUploader,
        ImageEditor
    }
}
</script>